var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17V19C13.5 19.5304 13.2893 20.0391 12.9142 20.4142C12.5391 20.7893 12.0304 21 11.5 21H3.5C2.96957 21 2.46086 20.7893 2.08579 20.4142C1.71071 20.0391 1.5 19.5304 1.5 19V8C1.5 7.46957 1.71071 6.96086 2.08579 6.58579C2.46086 6.21071 2.96957 6 3.5 6H5.5M5.5 3V15C5.5 15.5304 5.71071 16.0391 6.08579 16.4142C6.46086 16.7893 6.96957 17 7.5 17H15.5C16.0304 17 16.5391 16.7893 16.9142 16.4142C17.2893 16.0391 17.5 15.5304 17.5 15V6.242C17.5 5.97556 17.4467 5.71181 17.3433 5.46624C17.2399 5.22068 17.0885 4.99824 16.898 4.812L13.583 1.57C13.2094 1.20466 12.7076 1.00007 12.185 1H7.5C6.96957 1 6.46086 1.21071 6.08579 1.58579C5.71071 1.96086 5.5 2.46957 5.5 3Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.53054862.svg";
export { ForwardRef as ReactComponent };